var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAiThumbUp = function SvgAiThumbUp(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,10 L11,4 C11.6,3.1 13,3.5 13,4.7 L13,9 L19,9 C20.3,9 21.2,10.2 20.8,11.5 L18.7,18.5 C18.4,19.4 17.7,20 16.7,20 L7,20 M7,10 H4 C3.45,10 3,10.45 3,11 V19 C3,19.55 3.45,20 4,20 H7 Z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAiThumbUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/aiThumbUp.e3e6e047.svg";
export { ForwardRef as ReactComponent };